<div class="loader-ct">
  <div class="loader-hide">
    <div class="loader"></div>
  </div>
</div>
